module.exports = __webpack_public_path__ + "media/images/illustrations/wave-white-3-7defce63fc87292a8cce003dd0ff82ad.svg";